<!--负荷实时分析-->
<template>
	<div>
		<p class="bigTitle">负荷实时分析</p>
		<vchart style="height: calc(100% - 68px);margin-top: 19px;" themes="UbiquitousOverviewChartSkin" ref='vchart'></vchart>
	</div>
</template>

<script>
	import vchart from '@/components/module/chart/vchart.vue'
	export default {
		components: {
			vchart
		},
		props: {},
		data() {
			return {
				options: {},
			}
		},
		created() {},
		mounted() {
			//初始化图表
			this.options = this.$refs.vchart.getDefaultOptions()
			this.options.title.show = false
			this.options.grid = {
				top: 10,
				bottom: 30
			}
			this.options.toolbox.show = false
			this.options.legend = {
				bottom: 0,
				right: 0,
				textStyle:{
					color:"white"
				}
			}
			this.$refs.vchart.setData(this.options, true)
			this.initData()
		},
		destroyed() {},
		computed: {},
		watch: {},
		methods: {
			initData() {
				var dataList = []
				var today = []
				var yestoday = []
				var date = new Date("2019-01-01 00:00:00")
				var now = Date.now() - new Date(new Date().formatByDate()).getTime()
				for (var i = 0; i < 288; i++) {
					var time = date.formatByTime().split(' ')[1]
					if (i * 5 * 60 * 1000 < now) {
						today.push([time, i == 0 ? 885 : today[i - 1][1] + (i % 100 < 50 ? 10 : -5)])
					}
					yestoday.push([time, i == 0 ? 795 : yestoday[i - 1][1] + (i % 100 < 50 ? 10 : -5)])
					date.setTime(date.getTime() + 5 * 60 * 1000)
				}
				var legend = ["昨日负荷", "今日负荷"]
				var seriesList = [{
					name: "昨日负荷",
					type: 'line',
					smooth: true,
					symbol: 'emptyCircle',
					sampling: 'average',
					data: yestoday,
				}, {
					name: "今日负荷",
					type: 'line',
					smooth: true,
					symbol: 'emptyCircle',
					sampling: 'average',
					data: today,
				}]
				this.options.series = seriesList
				this.options.legend.data = legend
				this.$refs.vchart.setData(this.options, true)
			}
		}
	}
</script>

<style scoped>
	p.bigTitle {
		width: 100%;
		color: #00C6FF;
		font-size: 18px;
		font-weight: bold;
		text-align: center;
		margin-top: 15px;
		margin-bottom: 20px;
	}
</style>
